var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9211 4.11876C21.3782 1.5774 17.8882 0 14.0124 0C6.26088 0 0 6.27453 0 14.0213C0 21.7681 6.26088 28.0426 14.0124 28.0426C20.5539 28.0426 26.0081 23.5733 27.5689 17.5266H23.9211C22.483 21.6103 18.5897 24.5373 14.0124 24.5373C8.20754 24.5373 3.48996 19.8226 3.48996 14.0213C3.48996 8.21999 8.20754 3.50533 14.0124 3.50533C16.9237 3.50533 19.5192 4.71466 21.4133 6.62507L15.7662 12.2686H28.0424V0L23.9211 4.11876Z",
    fill: "#5D5DED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.d37e0495b93012565ef97a8b4bbfc013.svg";
export { ForwardRef as ReactComponent };